<palantir-content class="palantir-card">
  <palantir-layout>
    <ng-content select="[palantir-card-thumbnail], palantir-card-thumbnail" />
    <ng-content select="[palantir-card-header], palantir-card-header" />
    <ng-content select="[palantir-card-content], palantir-card-content" />
    <ng-content select="[palantir-card-footer], palantir-card-footer" />
  </palantir-layout>
</palantir-content>
